// extracted by mini-css-extract-plugin
export default {"title":"MasterSaleDetails_title__iAyjr","total":"MasterSaleDetails_total__3rCHl","edit":"MasterSaleDetails_edit__epFmn","cancel":"MasterSaleDetails_cancel__XMBje"};